export const addOnTypeLabels: Record<string, string> = {
  BENCH_TAX: 'Bench Tax',
  CASH_RECONCILIATION: 'Cash Reconciliation',
  CHECKS: 'Checks',
  CUSTOM_ADJUSTEMENTS: 'Custom Adjustments',
  INTERCOMPANY_LOAN: 'Intercompany Loan',
  LOAN_LOC_CAPITAL_LEASE: 'Loan / LOC / Lease',
  MERCHANT_PROCESSOR: 'Merchant Processor',
  OTHER: 'Other',
  PAYROLL: 'Payroll Provider',
  PERSON_CONTRIBUTION: 'Personal Contribution',
  PERSONAL_BUSINESS_CROSSOVER: 'Personal-Business Crossover',
  PRO: 'PRO',
  RECEIPTS: 'Receipts',
  REIMBURSEMENTS: 'Reimbursements',
  TAGGING_AND_REPORTING: '1099 Tagging & Reporting',
};
